module.exports = __webpack_public_path__ + "img/template_2.81e2d2a8.png";